/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import React from 'react';
import _ from 'underscore';
import * as DateUtils from '../date_utils';
import { InstanceListItem } from './instance_list_item.jsx';

const NUM_SHOWN_INSTANCES = 13;

export class InstanceList extends React.Component {
        static initClass() {
          this.state = {};
        }

        constructor(props) {
          super(props);
          this.componentDidMount = this.componentDidMount.bind(this);
          this.componentWillUnmount = this.componentWillUnmount.bind(this);
          this.render = this.render.bind(this);
          this._instanceListChanged = this._instanceListChanged.bind(this);
          this._instanceChanged = this._instanceChanged.bind(this);
          this._isInstanceHidden = this._isInstanceHidden.bind(this);
          this._unhideInstance = this._unhideInstance.bind(this);
this._showAllInstances = this._showAllInstances.bind(this);

          const instances = this.props.eventInstances.instances || [];
          const num_instances = this.props.eventInstances.count();
          const hidden_dates = [];

          // If we're over 10 instances, hide some dates
          if (num_instances > NUM_SHOWN_INSTANCES) {
            for (const instance of Array.from(instances.slice(NUM_SHOWN_INSTANCES))) { hidden_dates.push(instance.start_date); }
          }

          this.state = {instances, num_instances, hidden_dates};
        }

        componentDidMount() {
          this.props.eventInstances.on('slzr:instance:add', this._instanceListChanged);
          this.props.eventInstances.on('slzr:instance:change', this._instanceListChanged);
          return this.props.eventInstances.on('slzr:instance:remove', this._instanceListChanged);
        }

        componentWillUnmount() {
          this.props.eventInstances.removeListener('slzr:instance:add', this._instanceListChanged);
          this.props.eventInstances.removeListener('slzr:instance:change', this._instanceListChanged);
          return this.props.eventInstances.removeListener('slzr:instance:remove', this._instanceListChanged);
        }

        render() {
          const instance_items = (() => {
            const result = [];
            for (let index = 0; index < this.state.instances.length; index++) {
              const instance = this.state.instances[index];
              const is_hidden = this._isInstanceHidden(instance);

              let item_key = `${index}-${  Number(instance.start_date)}`;
              if (instance.start_time != null) { item_key += Number(instance.start_time); }

              result.push(<InstanceListItem instance={instance}
                                 eventInstances={this.props.eventInstances}
                                 index={index}
                                 key={item_key}
                                 onInstanceChanged={this._instanceChanged.bind(this, index)}
                                 hidden={is_hidden}
                                 isRenderedInAdmin={this.props.isRenderedInAdmin}
                                 showReservationStatusColumn={this.props.showReservationStatusColumn}
                                 readOnly={this.props.readOnly}
                                 timeZoneName={this.props.timeZoneName}
                />);
            }
            return result;
          })();

          // Expand link, if we're hiding any dates
          const expand_link = (() => {
            if (this.state.hidden_dates.length > 0) {
            const last_date = _.last(this.state.instances).start_date.toString(Slzr.Formats.LongDate);
            const message = `${this.state.hidden_dates.length} more through ${last_date}`;

            return <div className="item event_item">
              <a href="#" onClick={this._showAllInstances}>{message}</a>
            </div>;
          } 
            return null;
          
          })();

          return <div className="instance_list">
            {instance_items}
            {expand_link}
          </div>;
        }

        // Event handler when the instance list changes, refresh instance state
        _instanceListChanged(instance) {
          // Always show an instance after it's modified
          this._unhideInstance(instance);

          return this.setState({
            instances: this.props.eventInstances.instances,
            num_instances: this.props.eventInstances.count()
          });
        }

        // Callback when an instance is updated by the user
        _instanceChanged(index, instance_data) {
          const {
            start_date
          } = instance_data;
          const start_time = (() => { switch (instance_data.start_time) {
                         case 'blank': case 'invalid': return '';
                         default: return instance_data.start_time;
          } })();
          const end_time   = (() => { switch (instance_data.end_time) {
                         case 'blank': case 'invalid': return '';
                         default: return instance_data.end_time;
          } })();

          return this.props.eventInstances.update(index, start_date, start_time, end_time);
        }

        // Returns true if this instance is hidden
        _isInstanceHidden(instance) {
          return _.any(this.state.hidden_dates, date => DateUtils.sameDate(date, instance.start_date));
        }

        _unhideInstance(instance) {
          const hidden_dates = _.reject(this.state.hidden_dates, date => DateUtils.sameDate(date, instance.start_date));
          return this.setState({hidden_dates});
        }

        _showAllInstances(evt) {
          this.setState({hidden_dates: []});
          return evt.preventDefault();
        }
      }
InstanceList.initClass();
